<div class="panel-header">
    <div class="header-left">
        <gsp-button
            *ngIf="showBackButton"
            [type]="ButtonType.Icon"
            [iconClass]="backButtonIcon"
            [disabled]="disableBackAction"
            (click)="onBackClick()"
        ></gsp-button>
        <h2 *ngIf="headerTitle">{{ headerTitle | translate }}</h2>
        <ng-content select="[leftContent]"></ng-content>
    </div>

    <div class="header-right">
        <ng-container *ngIf="actionItems && actionItems.length > 0">
            <gsp-button
                *ngFor="let item of actionItems"
                [type]="ButtonType.Icon"
                [iconClass]="item.iconClass"
                [modusIcon]="item.custom?.modusIcon"
                [ngClass]="{ active: item.custom?.active }"
                [disabled]="disabled || item.disabled"
                [title]="item.title | translate"
                (click)="onActionClick(item, $event)"
            ></gsp-button>
        </ng-container>
        <ng-content select="[rightContent]"></ng-content>
    </div>
</div>
